import { AlertCircle } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { detectSectorMismatch } from "@/utils/sectorMismatch";

type SectorMismatchAlertProps = {
  notificareSectors: string[];
  decizieSectors: string[];
};

export default function SectorMismatchAlert({
  notificareSectors,
  decizieSectors,
}: SectorMismatchAlertProps) {
  const mismatch = detectSectorMismatch(notificareSectors, decizieSectors);

  if (!mismatch.hasMismatch) return null;

  return (
    <Alert variant="warning">
      <AlertCircle className="h-4 w-4 mt-0.5" />
      <AlertTitle className="text-sm font-semibold">
        Sectoare diferite detectate
      </AlertTitle>
      <AlertDescription className="text-xs space-y-1.5 mt-1">
        <p>
          Sectoarele din Decizia de Inregistrare nu corespund cu cele din
          Formularul de Notificare.
        </p>
        {mismatch.onlyInDecizie.length > 0 && (
          <div>
            <span className="font-medium">Doar in Decizie:</span>
            <ul className="mt-0.5 space-y-0.5">
              {mismatch.onlyInDecizie.map((sector) => (
                <li key={sector} className="flex items-center gap-2">
                  <span className="w-1 h-1 rounded-full bg-amber-400 shrink-0" />
                  {sector}
                </li>
              ))}
            </ul>
          </div>
        )}
        {mismatch.onlyInNotificare.length > 0 && (
          <div>
            <span className="font-medium">Doar in Notificare:</span>
            <ul className="mt-0.5 space-y-0.5">
              {mismatch.onlyInNotificare.map((sector) => (
                <li key={sector} className="flex items-center gap-2">
                  <span className="w-1 h-1 rounded-full bg-amber-400 shrink-0" />
                  {sector}
                </li>
              ))}
            </ul>
          </div>
        )}
      </AlertDescription>
    </Alert>
  );
}
